/** Stored document path for the app homepage (`GET /`). */
export const HOME_DOCUMENT_PATH = 'home';
